import React, { useEffect } from "react";
import { MobXProviderContext, Observer } from "mobx-react";

// Sagres Rotas React example components
import { Box, Button, Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, ListItem, Slide, TextField, Typography } from "@mui/material";
import Header from "components/Header/Header";
import { AddCircle, Delete, Edit } from "@mui/icons-material";
import SwitchStatusEntregador from "./switchStatus";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    neutral: {
      main: "#3c4392",
      contrastText: "#fff"
    },
    danger: {
      main: "#DC3545",
      contrastText: "#fff"
    }
  }
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

function EntregadoresView() {
  const { entregadoresStore } = React.useContext(MobXProviderContext);
  const [open, setOpen] = React.useState(false);
  const [openExcluir, setOpenExcluir] = React.useState(false);
  const [openUsuario, setOpenUsuario] = React.useState(false);
  const [openConfirmarUsuario, setOpenConfirmarUsuario] = React.useState(false);

  const [nome, setNome] = React.useState("");
  const [nomeResumido, setNomeResumido] = React.useState("");
  const [celular, setCelular] = React.useState("");
  const [codEntregador, setCodEntregador] = React.useState("");
  const [cor, setCor] = React.useState("#d8e580");
  const [usarCor, setUsarCor] = React.useState(false);
  const [idEntregador, setIdEntregador] = React.useState(-1);
  const [login, setLogin] = React.useState("");
  const [senha, setSenha] = React.useState("");
  const [ativoUsuario, setAtivoUsuario] = React.useState(1);
  const [temLogin, setTemLogin] = React.useState(false);
  const [novoEntregadorData, setNovoEntregadorData] = React.useState(null);
  const [isEdicao, setIsEdicao] = React.useState(false);

  const handleClickOpen = () => {
    setNome('');
    setNomeResumido('');
    setCelular('');
    setCodEntregador('');
    setCor('#d8e580');
    setUsarCor(false);
    setIsEdicao(false);
    setOpen(true);
  };

  const [entregadorAtual, setEntregadorAtual] = React.useState(null);

  const handleClickOpenEdit = (entregador) => {
    setNome(entregador?.Nome ?? '');
    setNomeResumido(entregador?.NomeResumido ?? '');
    setCelular(entregador?.Celular ?? '');
    setCodEntregador(entregador?.CodigoExternoEntregador ?? '');
    const temCor = entregador?.Cor && entregador?.Cor.trim() !== '';
    setCor(entregador?.Cor || '#d8e580');
    setUsarCor(temCor);
    setIdEntregador(entregador?.EntregadorId ?? -1);
    setTemLogin(entregador?.Login && entregador?.Login.trim() !== '');
    setEntregadorAtual(entregador); // Guarda o entregador completo
    setIsEdicao(true);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenExcluir = (entregador) => {
    setIdEntregador(entregador?.EntregadorId ?? -1);
    setNome(entregador?.Nome ?? '');
    setOpenExcluir(true);
  }

  const handleCloseExcluir = () => {
    setOpenExcluir(false);
  }

  const handleChangeNome = (e) => {
    setNome(e.target.value);
  };

  const handleChangeNomeResumido = (e) => {
    setNomeResumido(e.target.value);
  };

  const handleChangeCelular = (e) => {
    setCelular(e.target.value);
  };

  const handleChangeCodEntregador = (e) => {
    setCodEntregador(e.target.value);
  };

  const handleChangeCor = (e) => {
    setCor(e.target.value);
  };

  const handleChangeUsarCor = (e) => {
    setUsarCor(e.target.checked);
  };

  const enviar = () => {
    const corFinal = usarCor ? cor : '';
    entregadoresStore.cadastrarEntregador(nome, nomeResumido, celular, codEntregador, corFinal).then((res) => {
      if (entregadoresStore.error === "" && res) {
        setOpen(false);
        // Get the newly created entregador data from the response
        if (res.Registros && res.Registros.length > 0) {
          const novoEntregador = res.Registros[0];
          setNovoEntregadorData(novoEntregador);
          setOpenConfirmarUsuario(true);
        }
      }
    });
  };

  const handleClickAtivarUsuario = (entregador = null) => {
    // Se o entregador for passado e já tiver login, pré-preenche os dados
    if (entregador && entregador.Login) {
      setLogin(entregador.Login || '');
      setSenha(''); // Não pré-preenche senha por segurança, mas permite edição
      setAtivoUsuario(entregador.UsuarioAtivo ?? 1);
    } else {
      setLogin('');
      setSenha('');
      setAtivoUsuario(1);
    }
    setOpenUsuario(true);
  };

  const handleCloseUsuario = () => {
    setOpenUsuario(false);
  };

  const handleCloseConfirmarUsuario = () => {
    setOpenConfirmarUsuario(false);
    setNovoEntregadorData(null);
  };

  const handleConfirmarAtivarUsuario = () => {
    setOpenConfirmarUsuario(false);
    setLogin('');
    setSenha('');
    setOpenUsuario(true);
  };

  const handleChangeLogin = (e) => {
    setLogin(e.target.value);
  };

  const handleChangeSenha = (e) => {
    setSenha(e.target.value);
  };

  const handleChangeAtivoUsuario = (e) => {
    setAtivoUsuario(e.target.checked ? 1 : 0);
  };

  const enviarUsuario = () => {
    const entregadorId = novoEntregadorData ? novoEntregadorData.EntregadorId : idEntregador;
    const entregadorNome = novoEntregadorData ? novoEntregadorData.Nome : nome;

    entregadoresStore.cadastrarUsuarioEntregador(entregadorId, entregadorNome, login, senha, ativoUsuario).then(() => {
      if (entregadoresStore.error === "") {
        setOpenUsuario(false);
        setNovoEntregadorData(null);
        setLogin('');
        setSenha('');
        setAtivoUsuario(1);
      }
    });
  };

  const editar = () => {
    const corFinal = usarCor ? cor : '';
    entregadoresStore.editarEntregador(idEntregador, nome, nomeResumido, celular, codEntregador, corFinal).then(() => {
      if (entregadoresStore.error === "") {
        setOpen(false);
      }
    });
  };

  const excluir = () => {
    entregadoresStore.excluirEntregador(idEntregador).then(() => {
      if (entregadoresStore.error === "") {
        setOpenExcluir(false);
      }
    });
  };


  var height = window.innerHeight

  useEffect(() => {
    entregadoresStore.buscarEntregadores();
  }, []);

  return (
    <div>
        <Header />
        <ThemeProvider theme={theme}>

        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{isEdicao ? 'Editar Entregador' : 'Novo Entregador'}</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="selecionar-entregador">
            Lista de entregadores
          </DialogContentText> */}
            <Box sx={{ minWidth: 250 }} >
              <Observer>
                {() => (
                  <FormControl fullWidth>
                    <TextField fullWidth id="select-nome" label="Código Do Entregador" variant="standard" type="text" value={codEntregador} onChange={handleChangeCodEntregador} style={{ paddingBottom: 5 }} />
                    <TextField fullWidth id="select-nome" label="Nome" variant="standard" type="text" value={nome} onChange={handleChangeNome} style={{ paddingBottom: 5 }} />
                    <TextField fullWidth id="select-nome" label="Nome Resumido" variant="standard" type="text" value={nomeResumido} onChange={handleChangeNomeResumido} style={{ paddingBottom: 5 }} />
                    <TextField fullWidth id="select-nome" label="Celular" variant="standard" type="text" value={celular} onChange={handleChangeCelular} style={{ paddingBottom: 5 }} />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={usarCor}
                          onChange={handleChangeUsarCor}
                          color="primary"
                        />
                      }
                      label="Usar cor personalizada?"
                      style={{ marginTop: 16, marginBottom: 8 }}
                    />

                    {usarCor && (
                      <TextField fullWidth id="select-cor" label="Cor do Marcador" variant="standard" type="color" value={cor} onChange={handleChangeCor} style={{ paddingBottom: 5 }} />
                    )}

                    <Typography variant="body2" color="red">
                      {`${entregadoresStore.error !== "" ? entregadoresStore.error : ""}`}
                    </Typography>
                  </FormControl>
                )}
              </Observer>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            {isEdicao && (
              <Button variant="contained" color="neutral" onClick={() => handleClickAtivarUsuario(entregadorAtual)}>
                {temLogin ? 'Editar' : 'Ativar'} Sagres Entregadores
              </Button>
            )}
            {!isEdicao ? <Button variant="contained" color="primary" onClick={enviar} disabled={nome === "" || nomeResumido === "" || codEntregador === ""}>
              Salvar
            </Button> : <div />}
            {isEdicao ? <Button variant="contained" color="primary" onClick={editar} disabled={nome === "" || nomeResumido === "" || codEntregador === ""}>
              Editar
            </Button> : <div />}
          </DialogActions>
        </Dialog>

        <Dialog
          open={openExcluir}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseExcluir}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Excluir entregador?</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="selecionar-entregador">
            Lista de entregadores
          </DialogContentText> */}
            <Box sx={{ minWidth: 250 }} >
              <Observer>
                {() => (
                  <Grid container direction="column" fullWidth>
                    <Typography >
                      Deseja excluir o entregador {nome}?
                    </Typography>
                    <Typography variant="body2" color="red">
                      {`${entregadoresStore.error !== "" ? entregadoresStore.error : ""}`}
                    </Typography>
                  </Grid>
                )}
              </Observer>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseExcluir}>Cancelar</Button>
            
            <Button variant="contained" color="danger"  onClick={excluir}>
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de confirmação para ativar Sagres Entregadores após cadastro */}
        <Dialog
          open={openConfirmarUsuario}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseConfirmarUsuario}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Ativar Sagres Entregadores?</DialogTitle>
          <DialogContent>
            <Box sx={{ minWidth: 250 }}>
              <Typography>
                Deseja ativar o Sagres Entregadores para o novo entregador?
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmarUsuario}>Não</Button>
            <Button variant="contained" color="primary" onClick={handleConfirmarAtivarUsuario}>
              Sim
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog para cadastrar usuário/senha do Sagres Entregadores */}
        <Dialog
          open={openUsuario}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseUsuario}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Cadastrar - Sagres Entregadores</DialogTitle>
          <DialogContent>
            <Box sx={{ minWidth: 250 }}>
              <Observer>
                {() => (
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      id="login-usuario"
                      label="Usuário"
                      variant="standard"
                      type="text"
                      value={login}
                      onChange={handleChangeLogin}
                      style={{ paddingBottom: 5, marginTop: 8 }}
                    />
                    <TextField
                      fullWidth
                      id="login-senha"
                      label="Senha"
                      variant="standard"
                      type="password"
                      value={senha}
                      onChange={handleChangeSenha}
                      style={{ paddingBottom: 5 }}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={ativoUsuario === 1}
                          onChange={handleChangeAtivoUsuario}
                          color="primary"
                        />
                      }
                      label="Ativo no App?"
                      style={{ marginTop: 16, marginBottom: 8 }}
                    />
                    <Typography variant="body2" color="red">
                      {`${entregadoresStore.error !== "" ? entregadoresStore.error : ""}`}
                    </Typography>
                  </FormControl>
                )}
              </Observer>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseUsuario}>Cancelar</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={enviarUsuario}
              disabled={login === "" || senha === ""}
            >
              Cadastrar
            </Button>
          </DialogActions>
        </Dialog>

        <div style={{ position: 'relative', width: '100%', height: `${height - 130}px` }}>

          <Card style={{ height: '105%', margin: '32px', padding: 0, }}>
            <CardContent style={{ padding: 0 }}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" padding={2} >
                <Typography xs={10} gutterBottom variant="h5" component="div" style={{ marginLeft: 5, paddingTop: 16, paddingLeft: 8 }}>
                  Entregadores
                </Typography>

                <Grid item>
                  <Button variant="contained" color="primary" endIcon={<AddCircle />} onClick={handleClickOpen}>Cadastrar</Button>
                </Grid>
              </Grid>

              <Observer >{() =>
                <div style={{
                  display: "flex",
                  // flexFlow: "column wrap",
                  flexFlow: "column",
                  gap: "0 15px",
                  height: `${height - 190}px`,
                  overflow: "auto"
                }}>
                  {entregadoresStore.entregadores.length > 0 ? entregadoresStore.entregadores.map((entregador) => (
                    <ListItem key={entregador.EntregadorId} style={{
                      width: "auto"
                    }}>
                      <div style={{ width: '100%', paddingTop: 8, paddingBot: 8, paddingLeft: 16, paddingRight: 16 }}>

                        <Card style={{ width: '100%', paddingTop: 8 }} >
                          <CardContent>
                            <Grid container
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center">

                              <Grid item xs={10} container direction="column" >
                                <Typography gutterBottom variant="h5" component="div">
                                  {`${entregador.CodigoExternoEntregador} - ${entregador.Nome}`}
                                </Typography>
                                {/* <Typography variant="body2" fontWeight='fontWeightMedium' gutterBottom>
                                  {`${entregador.Ativo === 1 ? 'Ativo' : 'Inativo'}`}
                                  </Typography> */}
                                <Typography gutterBottom variant="h6" color="text.secondary">
                                  {`${entregador.Celular} `}
                                </Typography>
                                <Grid container direction="row" spacing={2}>
                                  <Grid item>
                                    <Button variant="contained" color="primary" endIcon={<Edit />} onClick={handleClickOpenEdit.bind(this, entregador)}>Editar</Button>
                                  </Grid>
                                  <Grid item>
                                    <Button variant="contained" color="danger" endIcon={<Delete />} onClick={handleClickOpenExcluir.bind(this, entregador)}>Excluir</Button>
                                  </Grid>
                                </Grid>

                                {/* <Typography variant="body2" color="text.secondary">
                                  {`${entregador.entregador.Nome !== undefined ? ' Entregador: ' + entregador.entregador.Nome : ''}`}
                                  </Typography> */}
                              </Grid>

                              <Grid item xs={2} container direction="column" justifyContent="center" alignItems="flex-end">
                                <SwitchStatusEntregador entregador={entregador} />
                              </Grid>
                            </Grid>


                          </CardContent>
                        </Card>
                      </div>
                    </ListItem>
                  )) : <Typography style={{ opacity: 0.5 }} variant="h6" gutterBottom>
                    'Não há entregadores cadastrados no momento.'

                  </Typography>}
                </div>



              }</Observer>
            </CardContent>
          </Card>
        </div>
      </ThemeProvider>
    </div>
  );
}

export default EntregadoresView;
